import {
    Component
} from "../../../../../../sedestral/framework/interface/component/Component";
import * as s from "./website-black-words.scss";
import {Resources} from "../../../../../../resources/Resources";
import {WebsiteBlackWordsStatsComponent} from "./stats/WebsiteBlackWordsStatsComponent";

export class WebsiteBlackWordsComponent extends Component {
    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentWebsiteBlackWords}">
                <div class="${s.what}">
                    <div class="${s.ai}">
                        <div class="${s.blur}"></div>
                        <div class="${s.icon}"></div>
                    </div>
                    <div class="${s.text}">
                        ${Resources.t("words.sedestralAiIntro")}
                    </div>
                </div>
                <div class="${s.numbers}">
                    <div class="${s.number} ${s.purple}">
                        <div class="${s.integer}">
                            <div class="${s.blur}"></div>
                            <div class="${s.text}">
                                50+
                            </div>
                        </div>
                        <div class="${s.description}">
                            ${Resources.t("words.metricsUsed")}
                        </div>
                    </div>
                    <div class="${s.number} ${s.blue}">
                        <div class="${s.integer}">
                            <div class="${s.blur}"></div>
                            <div class="${s.text}">
                                350 000
                            </div>
                        </div>
                        <div class="${s.description}">
                            ${Resources.t("words.wordsAnalyzed")}
                        </div>
                        <div class="${s.line}"></div>
                    </div>
                </div>

                ${this.draw(new WebsiteBlackWordsStatsComponent({
                    description: Resources.t("words.sedestralAiExploration"),
                    entries: [
                        {title: Resources.t("words.sedestralAnalysis"), color: "blue", width: "100%", value: "350K"},
                        {title: Resources.t("words.firstFourHarryPotter"), color: "white", width: "90%", value: "327K"},
                        {title: Resources.t("words.nineStarWarsFilms"), color: "white", width: "70%", value: "267K"},
                        {title: Resources.t("words.lotrAndHobbit"), color: "white", width: "50%", value: "192K"}
                    ]
                }))}
            </div>
        `;
    }

    commit() {

        super.commit();
    }

}
